import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";

const LoginPage = ({ onLoginSuccess }) => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  // ✅ Handle Login
  const handleLogin = async () => {
    try {
      const result = await api.checkLogin(userName, password);
      const table = result?.AssetCheckLoginApi?.Table || [];
      const loginData = table[0];

      if (loginData?.Loginmsg === "Success") {
        showMessage("✅ Login Successful!", "success");

        // ✅ Save session data
        sessionStorage.setItem("userName", loginData.UsrName);
        sessionStorage.setItem("userId", loginData.Usrid);
        localStorage.setItem("isLoggedIn", "true");

        console.log("userName:", loginData.UsrName);
        console.log("userId:", loginData.Usrid);

        // ✅ Fetch and store company details immediately
        await fetchCompanyDetails(loginData.UsrName);

        // ✅ Notify parent component (if needed)
        if (onLoginSuccess) onLoginSuccess();

        // ✅ Navigate to dashboard
        navigate("/dashboard", { replace: true });
      } else {
        showMessage("❌ Username or Password incorrect", "error");
      }
    } catch (error) {
      console.error("Login failed:", error);
      showMessage("❌ Login Failed: " + error.message, "error");
    }
  };

  // ✅ Fetch Company Details API (after login)
 const fetchCompanyDetails = async (userName) => {
  try {
    const response = await api.CompanyDetailsAPI(userName);
    console.log("CompanyDetailsAPI Response:", response);

    // ✅ Handle both possible response formats
    const table =
      response?.CompanyDetailsAPIjs?.Table ||
      response?.Table ||
      response?.CompanyDetailsAPIjs ||
      [];

    const company = table[0];

    if (company) {
      sessionStorage.setItem("companyId", company.Comid);
      sessionStorage.setItem("companyName", company.Comname);
      sessionStorage.setItem("companyPropName", company.PropName);

      console.log("✅ Company Details Saved:", company);
    } else {
      console.warn("⚠️ No company details found in API response:", response);
    }
  } catch (err) {
    console.error("❌ Error fetching company details:", err);
  }
};

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>ERP-Maintenance 🔑</h2>
        <img
          src="https://cdn-icons-png.flaticon.com/512/295/295128.png"
          alt="Login"
          style={styles.image}
        />

        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter Username"
          style={styles.input}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter Password"
          style={styles.input}
        />

        <button onClick={handleLogin} style={styles.button}>
          Login
        </button>

        {message && (
          <div
            style={{
              ...styles.toast,
              backgroundColor:
                message.type === "success" ? "#4caf50" : "#f44336",
            }}
          >
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
};

// 🎨 Styles (same as yours)
const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center",
    width: "400px",
    maxWidth: "90%",
    position: "relative",
  },
  image: {
    width: "100px",
    marginBottom: "20px",
  },
  input: {
    padding: "12px",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    marginBottom: "15px",
    outline: "none",
  },
  button: {
    backgroundColor: "#667eea",
    color: "#fff",
    padding: "12px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    width: "100%",
  },
  toast: {
    marginTop: "20px",
    padding: "12px",
    borderRadius: "8px",
    color: "#fff",
    fontWeight: "bold",
    animation: "fadeInOut 3s ease",
  },
};

export default LoginPage;

 

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../../api/api";

// const LoginPage = ({ onLoginSuccess }) => {
//   const [userName, setUserName] = useState("");
//   const [password, setPassword] = useState("");
//   const [message, setMessage] = useState(null);
//   const navigate = useNavigate();

//   const showMessage = (text, type = "success") => {
//     setMessage({ text, type });
//     setTimeout(() => setMessage(null), 3000);
//   };

//   const handleLogin = async () => {
//     try {
//       const result = await api.checkLogin(userName, password);
//       const table = result?.AssetCheckLoginApi?.Table || [];
//       const loginData = table[0];

//       if (loginData?.Loginmsg === "Success") {
//         showMessage("✅ Login Successful!", "success");

//         // ✅ Save session
//         sessionStorage.setItem("userName", loginData.UsrName);
//         sessionStorage.setItem("userId", loginData.Usrid);
//         localStorage.setItem("isLoggedIn", "true"); // ✅ ensure App detects login

//         // Debugging logs
//         console.log("userName:", loginData.UsrName);
//         console.log("userId:", loginData.Usrid);

//         // ✅ Inform App about successful login
//         if (onLoginSuccess) onLoginSuccess();

//         // ✅ Navigate after success
//         navigate("/dashboard", { replace: true });
//       } else {
//         showMessage("❌ Username or Password incorrect", "error");
//       }
//     } catch (error) {
//       console.error("Login failed:", error);
//       showMessage("❌ Login Failed: " + error.message, "error");
//     }
//   };

//   return (
//     <div style={styles.page}>
//       <div style={styles.card}>
//         <h2 style={styles.title}>ERP-Maintenance 🔑</h2>
//         <img
//           src="https://cdn-icons-png.flaticon.com/512/295/295128.png"
//           alt="Login"
//           style={styles.image}
//         />

//         <input
//           type="text"
//           value={userName}
//           onChange={(e) => setUserName(e.target.value)}
//           placeholder="Enter Username"
//           style={styles.input}
//         />
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           placeholder="Enter Password"
//           style={styles.input}
//         />

//         <button onClick={handleLogin} style={styles.button}>
//           Login
//         </button>

//         {message && (
//           <div
//             style={{
//               ...styles.toast,
//               backgroundColor:
//                 message.type === "success" ? "#4caf50" : "#f44336",
//             }}
//           >
//             {message.text}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // 🎨 Styles (same as yours)
// const styles = {
//   page: {
//     height: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     fontFamily: "Arial, sans-serif",
//   },
//   card: {
//     backgroundColor: "#fff",
//     padding: "40px",
//     borderRadius: "16px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//     textAlign: "center",
//     width: "400px",
//     maxWidth: "90%",
//     position: "relative",
//   },
//   image: {
//     width: "100px",
//     marginBottom: "20px",
//   },
//   input: {
//     padding: "12px",
//     width: "100%",
//     borderRadius: "8px",
//     border: "1px solid #ccc",
//     fontSize: "16px",
//     marginBottom: "15px",
//     outline: "none",
//   },
//   button: {
//     backgroundColor: "#667eea",
//     color: "#fff",
//     padding: "12px 20px",
//     border: "none",
//     borderRadius: "8px",
//     fontSize: "16px",
//     cursor: "pointer",
//     width: "100%",
//   },
//   toast: {
//     marginTop: "20px",
//     padding: "12px",
//     borderRadius: "8px",
//     color: "#fff",
//     fontWeight: "bold",
//     animation: "fadeInOut 3s ease",
//   },
// };

// export default LoginPage;

 